import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./observations.scss";

interface ObservationsProps {
  isOpen: boolean;
  onClose: () => void;
  content: string;
}

const Observations: React.FC<ObservationsProps> = ({
  isOpen,
  onClose,
  content,
}) => {
  const [selectedItem, setSelectedItem] = useState<number | null>(null);
  const IndividualObservations = (index: number) => {
    setSelectedItem(selectedItem === index ? null : index);
  };
  if (!isOpen) {
    return null;
  }
  return (
    <div className="observations-overlay">
      <div className="observations-content">
        <div className="observation-close-button" onClick={onClose}>
          {/* &times; */}
          <CloseIcon
            style={{
              color: "grey",
              fontSize: "1.2rem",
              backgroundColor: "#f5f5f5",
              borderRadius: "50%",
              transition: "transform 0.2s, color 0.2s",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.color = "#FF5E4F";
              e.currentTarget.style.transform = "scale(1.1)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.color = "grey";
              e.currentTarget.style.transform = "scale(1)";
            }}
          />
        </div>

        <div className="observations-text">{content}</div>
      </div>
    </div>
  );
};

export default Observations;
